// An SDK session notification is not evidence of a new login. This short-lived
// intent contains no address, password, token or account identifier.
import { analyticsAllowed } from './guestAnalytics';
const KEY = 'instanttranscriber_auth_activity_v1';
const TTL = 60 * 60 * 1000;
const METHODS = new Set(['google', 'apple', 'email', 'email_link']);
let memory = null;

export function rememberAuthAttempt(method, target = 'login') {
  if (!analyticsAllowed()) { clearAuthAttempt(); return; }
  if (!METHODS.has(method) || !['login', 'signup'].includes(target)) return;
  memory = { method, target, created_at: Date.now() };
  try { localStorage.setItem(KEY, JSON.stringify(memory)); } catch {}
}

export function clearAuthAttempt() {
  memory = null;
  try { localStorage.removeItem(KEY); } catch {}
}

export function consumeAuthAttempt(user) {
  if (!analyticsAllowed()) { clearAuthAttempt(); return null; }
  if (!user?.id || user.is_anonymous) return null;
  let attempt;
  try { attempt = JSON.parse(localStorage.getItem(KEY) || 'null') || memory; } catch { attempt = memory; }
  if (!attempt) return null;
  if (!METHODS.has(attempt.method) || !['login', 'signup'].includes(attempt.target)
      || !Number.isFinite(attempt.created_at) || Date.now() - attempt.created_at > TTL
      || attempt.created_at > Date.now() + 1000) {
    clearAuthAttempt();
    return null;
  }
  // A focused tab can restore the previous session while an OAuth flow runs.
  const signedInAt = Date.parse(user.last_sign_in_at);
  if (attempt.target === 'login' && Number.isFinite(signedInAt)
      && signedInAt < attempt.created_at - 10000) return null;
  if (attempt.target === 'signup' && attempt.method === 'email' && !user.email_confirmed_at) return null;
  const provider = user.app_metadata?.provider;
  if (['google', 'apple'].includes(attempt.method) && provider && provider !== attempt.method
      && !user.identities?.some(identity => identity.provider === attempt.method)) return null;
  // Consume before any analytics callback: focus, metadata updates and other
  // tabs cannot repeatedly report the same completed attempt.
  clearAuthAttempt();
  return attempt;
}
